













































































































import { Component, Vue } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import GiamSatTaiChinhTaoBaoCao from './GiamSatTaiChinhTaoBaoCao.vue'
import GiamSatTaiChinhDuLieuBaoCao from './GiamSatTaiChinhDuLieuBaoCao.vue'
import GSTCBaoCaoGanDay from './GSTCBaoCaoGanDay.vue'
import { CompanyGradeReport, CompanyManagerGradeReport, InvestmentStatusReport, RecentReport } from '@/utils/Interfaces'
import { getInvestmentStatusReport, postGSTCReportExcel, downloadGSTCReportExcel, getCompanyGradeReport, getCompanyManagerGradeReport, getRecentGSTCReports } from '@/utils/ApiServices'
import { handle } from '@/utils/ErrorHandling'
import { AxiosResponse } from 'axios'
import fileDownload from 'js-file-download'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
    GiamSatTaiChinhTaoBaoCao,
    GiamSatTaiChinhDuLieuBaoCao,
    GSTCBaoCaoGanDay,
  }
})
export default class GiamSatTaiChinh extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Giám sát tài chính',
      to: { name: 'GiamSatTaiChinh' },
    },
  ]
  companies = []
  searchText = ''
  recentReports = []

  loading = false
  showRecentReports = true
  showReportCreate = true
  showReportData = true

  // ======================================================================

  fetchingReports = true
  investmentStatusReports: Array<InvestmentStatusReport> = []
  companyGradeReports: Array<CompanyGradeReport> = []
  companyManagerGradeReports: Array<CompanyManagerGradeReport> = []

  fetchingRecentReports = false
  recentReportExcels: Array<RecentReport> = []

  mounted () {
    this.updateReportData()
    this.updateRecentReports()
  }

  updateReportData () {
    this.fetchingReports = true

    Promise.all([
      getInvestmentStatusReport(this.year),
      getCompanyGradeReport(this.year),
      getCompanyManagerGradeReport(this.year),
    ])
      .then(responses => {
        this.investmentStatusReports = responses[0].data
        this.companyGradeReports = responses[1].data
        this.companyManagerGradeReports = responses[2].data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingReports = false
      })
  }

  updateRecentReports () {
    this.fetchingRecentReports = true
    getRecentGSTCReports()
      .then(response => {
        this.recentReportExcels = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingRecentReports = false
      })
  }

  // ======================================================================

  year = (new Date).getFullYear() - 1  // Lấy 1 năm trước so với năm hiện tại
  reportTypes = ['02.B', '05.A', '05.B']

  downloading = false

  async download () {
    if (this.downloading) return
    this.downloading = true

    const response = await postGSTCReportExcel(this.year).catch(error => {
      this.downloading = false
      handle(error)
    }) as AxiosResponse
    const id = response.data.id

    downloadGSTCReportExcel(id)
      .then(response => {
        const filename = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim()
        fileDownload(response.data, filename)
        this.updateRecentReports()
      })
      .catch(error => {
        handle(error)
      })
      .finally(() => {
        this.downloading = false
      })
  }
}
